<div class="card-header bg-white d-flex justify-content-between align-items-center">
    <div>
        <i class="fas fa-file-signature text-gray text-opacity-50"></i>
        Histórico de Pólizas
    </div>
    @if(policySelected && !transferInsured){
    <div class="btn-group my-n1 flex-wrap">
        <button type="button" class="btn btn-white btn-sm border-0 text-gray dropdown-toggle mx-2 text-truncate"
            data-bs-toggle="dropdown" style="max-width: 180px;"><i class="fas fa-exchange-alt"></i> {{policySelected.code}} - {{policySelected.year}} <b
                class="caret"></b></button>
        <div class="dropdown-menu dropdown-menu-end">
            @for(p of listContractedPolicies; track p){
            <a href="javascript:;" class="dropdown-item" (click)="getHistoryContracts(p)">{{p.code}} - {{p.year}}</a>
            }
        </div>
        <button type="button" class="btn btn-white btn-sm border-0 text-gray dropdown-toggle"
            data-bs-toggle="dropdown">Opciones <b class="caret"></b></button>
        <div class="dropdown-menu dropdown-menu-end">
            <a href="javascript:;" class="dropdown-item" (click)="openNewPolicyModal(newPolicyModal)"> <i
                    class="fas fa-plus-circle"></i> Nueva Póliza</a>
            <div class="dropdown-divider"></div>
            <a href="javascript:;" class="dropdown-item" (click)="getHistoryContracts(policySelected)"> <i
                    class="fas fa-sync"></i> Actualizar</a>
            @if(policySelected.relationship.priority == 0){
            <a href="javascript:;" class="dropdown-item" (click)="createTransfer()"> <i
                    class="fas fa-people-arrows"></i> Modificar</a>
            }
        </div>

    </div>
    }@else if(transferInsured){
    <div class="btn-group my-n1">
        <button class="btn btn-outline-danger btn-xs" (click)="cancel()">Cancelar</button>
        <button class="btn btn-success btn-xs mx-2" [disabled]="transferForm.invalid" (click)="save()">{{action == 'modify' ? 'Guardar' : 'Trasladar'}}</button>
    </div>
    }

</div>

@if(showSpinner){
<app-state-display state="loading"></app-state-display>
}@else if(!transferInsured && policySelected) {
<div class="card-body p-3 text-dark fw-bold">
    <dl class="row">
        <div class="col-sm-6">
            <dt class="col-5"> <i class="fa fa-file-text-o"></i> Póliza:</dt>
            <dd class="col-7 text-nowrap">{{policySelected?.code}} - {{policySelected?.entity}}</dd>
        </div>
        <div class="col-lg-3 col-sm-6 text-nowrap">
            <dt class="col-5"><i class="fa fa-calendar"></i> Inicio Vigencia:</dt>
            <dd class="col-7">{{policySelected?.dateStart | date: 'dd-MM-yyyy': 'UTC'}}</dd>
        </div>
        <div class="col-lg-3 col-sm-6 text-nowrap">
            <dt class="col-5"> <i class="fa fa-calendar-times"></i> Termino Vigencia:</dt>
            <dd class="col-7">{{!policySelected?.dateFinish ? "En vigencia" : ( policySelected?.dateFinish | date:'dd-MM-yyyy': 'UTC')}}</dd>
        </div>
    </dl>
    <div class="table-responsive">
    <table class="table table-hover table-sm my-2">
        <thead>
            <tr>
                <th>N°</th>
                <th class="text-center">Periodo</th>
                <th class="text-center">Grupo</th>
                <th class="text-center">Tipo Aseg</th>
                <th class="text-center">Cargas</th>
                <th class="text-center">Capital</th>
                <th class="text-center">Total UF</th>
                <th class="text-center">Total $</th>
            </tr>
        </thead>
        <tbody>
            @for(cp of listPolicies; track cp; let i = $index){
            <tr>
                <td>{{ i + 1}}</td>
                <td class="text-center">{{cp.period | date: 'MM-yyyy': 'UTC'}}</td>
                <td class="text-center">{{cp.group?.name}}</td>
                <td class="text-center">{{cp.relationship.name}}</td>
                <td class="text-center">{{cp.coveredLives | number}}</td>
                <td class="text-center">{{cp.capital | number: '1.0-5'}}</td>
                <td class="text-center">{{cp.totalUF | number: '1.0-5'}}</td>
                <td class="text-center">{{cp.totalPesos | number: '1.0-0'}}</td>
            </tr>
            }
        </tbody>
    </table>
    </div>
</div>
}@else if(!transferInsured && !showIncorporationForm){
<app-state-display state="empty" message="Aún no se registran pólizas activas para este asegurado"></app-state-display>
<div class="card-body text-center pb-4">
    <button class="btn btn-primary" (click)="openNewPolicyModal(newPolicyModal)">
        <i class="fas fa-plus-circle"></i> Incorporar a Póliza
    </button>
</div>
}

<ng-template #newPolicyModal let-c="close" let-d="dismiss">
    <div class="modal-header d-flex justify-content-between">
        <h5 class="modal-title">Nueva Póliza</h5>
        <button type="button" class="close btn btn-sm btn-white m-r-1" (click)="d('Cross click')"><span
                aria-hidden="true">&times;</span></button>
    </div>
    <app-policy-information [insuredId]="insured._id" [hideNavigation]="true"
        [existingCoverageIds]="existingCoverageIds"
        [existingEntityIds]="existingEntityIds"
        (savePolicyInformation)="saveIncorporation($event)" (cancel)="d('Cancel')"
        (back)="d('Back')"></app-policy-information>
</ng-template>

@if(transferInsured){
<div class="card-body p-3 text-dark fw-bold">
    <h5>Datos Póliza Actual</h5>
    <dl class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-6">
            <dt class="col-5"> <i class="fa fa-file-text-o"></i> Poliza</dt>
            <dd class="col-7">{{actualContract.policy.code}} - {{actualContract.policy.entity.name}}</dd>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-4 col-sm-6 text-nowrap">
            <dt class="col-5"><i class="fa fa-user"></i> Grupo</dt>
            <dd class="col-7">{{actualContract.group.name}}</dd>
        </div>
        <div class="col-xl-1 col-lg-6 col-md-4 col-sm-6 text-nowrap">
            <dt class="col-5"> <i class="fa fa-ping"></i> Capital:</dt>
            <dd class="col-7">{{actualContract.capital }}</dd>
        </div>
        <div class="col-xl-2 col-lg-6 col-md-4 col-sm-6 text-nowrap">
            <dt class="col-5"> <i class="fa fa-ping"></i> Inicio Vigencia:</dt>
            <dd class="col-7">{{actualContract.dateStart | date: "dd-MM-yyyy": 'UTC'}}</dd>
        </div>
    </dl>
    <hr>
    <h5>Datos Póliza a Destino</h5>
    <div [formGroup]="transferForm" class="row">
        <div class="mt-2 col-lg-8 col-md-8 col-sm-6">
            <label for="transfer-entityId" class="fw-bold">Entidad</label>
            <ng-select [items]="listEntities" bindLabel="name" bindValue="_id" formControlName="entityId" id="transfer-entityId" placeholder="Entidad Destino" (change)="getPoliciesDestiny()"> </ng-select>
        </div>
        <div class="mt-2 col-lg-4 col-md-4 col-sm-6">
            <label for="transfer-policyId" class="fw-bold">Póliza</label>
            <ng-select [items]="policiesDestiny" bindLabel="code" bindValue="_id" formControlName="policyId" id="transfer-policyId" placeholder="Póliza Destino" (change)="getGroupOfPolicy($event)"> </ng-select>
        </div>
        <div class="mt-2 col-lg-3 col-md-6 col-sm-6">
            <label for="transfer-groupId" class="fw-bold">Grupo</label>
            <ng-select [items]="listGroups" bindLabel="name" bindValue="_id" formControlName="groupId" id="transfer-groupId" placeholder="Grupo Destino" (change)="getPositions()"> </ng-select>
        </div>
        <div class="mt-2 col-lg-3 col-md-6 col-sm-6">
            <label for="transfer-jobTitleId" class="fw-bold">Cargo</label>
            <ng-select [items]="listPositions" bindLabel="name" bindValue="_id" formControlName="jobTitleId" id="transfer-jobTitleId" placeholder="Cargo" (change)="setCapital($event)"> </ng-select>
        </div>
        <div class="mt-2 col-lg-3 col-md-2 col-sm-6">
            <label for="transfer-capital" class="fw-bold">Capital</label>
            @if(editableCapital){
                <input type="text" class="form-control" formControlName="capital" id="transfer-capital" placeholder="Sin puntos ni guión" >
                @if(transferForm.get('capital').touched && transferForm.get('capital').invalid){
                <small class="text-danger">Dato Obligatorio</small>
                }
            }@else {
                <span class="form-control-plaintext border-bottom px-2">{{transferForm.value.capital ? transferForm.value.capital : "-"}}</span>
            }
        </div>
        <div class="mt-2 col-lg-3 col-md-4 col-sm-6">
            <label for="transfer-dateStart" class="fw-bold">Fecha Vigencia Traslado</label>
            <input type="date" [min]="dateMin" class="form-control" formControlName="dateStart" id="transfer-dateStart">
            @if(transferForm.get('dateStart').touched && transferForm.get('dateStart').invalid){
            <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
    
    </div>
</div>

}